/**
 * 标准数独应用入口
 * 挂载到服务端渲染页面的 #game-sudoku-app 元素
 */
import { createApp } from 'vue'
import App from './App.vue'

const mountEl = document.getElementById('game-sudoku-app')

if (mountEl) {
    const app = createApp(App)

    if (import.meta.env.DEV) {
        app.config.performance = true
    }

    app.config.errorHandler = (err, _instance, info) => {
        console.error('[game-sudoku] Vue Error:', err)
        console.error('[game-sudoku] Error Info:', info)
    }

    app.mount(mountEl)
}
